import { Box, Icon } from '@ff-it/ui';
import { parseISO } from 'date-fns';
import { ReactElement } from 'react';
import { formatISODate } from 'utilities';

export function DeadlineDate({ deadline, late }: { deadline: string; late?: boolean }): ReactElement {
  const date = parseISO(deadline);

  const isLate = late === undefined ? date < new Date() : late;

  return (
    <Box as="span" fontWeight="semibold" title="deadline" whiteSpace="nowrap">
      {isLate && <Icon icon="fire" mr="0.5" ml="-0.5" color="error600" />}
      {formatISODate(date)}
    </Box>
  );
}
